import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { isEmpty, find, sumBy } from "lodash"
import { AddOrderApi } from "./POSActions";
import { getCoupons } from "../AddDetails/AddCoupons/Coupons.action";
import { getCustomerData, addCustomer } from "../AddDetails/AddCustomer/Customer.action";
import { filterItem, getProductData } from "../AddDetails/AddProduct/Product.action";
import { getCategoryData } from "../AddDetails/categories/Catagory.action";
import { filterItemByMenu } from "../AddDetails/Recipe/Recipe.action";
import { getProductTypeById } from "../AddDetails/Recipe/Recipe.action";
import { getRestaurantData } from "../AddDetails/AddResturant/Resturant.action";
import { useLocation, useNavigate } from "react-router-dom";
import { GlobalSpinner } from "../../../../global/globalFunctions";
import SinglePageDashbord from "../../drawer/SinglePageDashbord";
import Spinner from "react-bootstrap/Spinner";
import useScanDetection from "use-scan-detection";
import Swal from "sweetalert";


/* ── Google Font (Plus Jakarta Sans) ── */
if (typeof document !== "undefined" && !document.getElementById("pos-font")) {
  const l = document.createElement("link");
  l.id = "pos-font";
  l.rel = "stylesheet";
  l.href = "https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap";
  document.head.appendChild(l);
}

/* ── Design tokens ── */
const ACCENT = "#2563EB";
const ACCENT_LT = "#EFF6FF";
const ACCENT_DK = "#1D4ED8";
const SUCCESS = "#059669";
const SUCCESS_BG = "#ECFDF5";
const DANGER = "#DC2626";
const DANGER_BG = "#FEF2F2";
const GRAY50 = "#F9FAFB";
const GRAY100 = "#F3F4F6";
const GRAY200 = "#E5E7EB";
const GRAY300 = "#D1D5DB";
const GRAY400 = "#9CA3AF";
const GRAY500 = "#6B7280";
const GRAY700 = "#374151";
const GRAY900 = "#111827";
const FONT = "'Plus Jakarta Sans','Segoe UI',sans-serif";

const CARD_ACCENTS = [
  { bar: "#2563EB", bg: "#EFF6FF", text: "#1D4ED8" },
  { bar: "#7C3AED", bg: "#F5F3FF", text: "#6D28D9" },
  { bar: "#059669", bg: "#ECFDF5", text: "#047857" },
  { bar: "#D97706", bg: "#FFFBEB", text: "#B45309" },
  { bar: "#DB2777", bg: "#FDF2F8", text: "#BE185D" },
  { bar: "#0891B2", bg: "#ECFEFF", text: "#0E7490" },
];

const getCatIcon = (name = "") => {
  const n = name.toLowerCase();
  if (n.includes("phone") || n.includes("mobile")) return "📱";
  if (n.includes("laptop") || n.includes("computer")) return "💻";
  if (n.includes("food") || n.includes("meal")) return "🍽️";
  if (n.includes("drink") || n.includes("beverage")) return "🥤";
  if (n.includes("cloth") || n.includes("wear")) return "👕";
  if (n.includes("electr")) return "⚡";
  if (n.includes("audio") || n.includes("headphone")) return "🎧";
  return "📦";
};

/* ── Styles object ── */
const S = {
  root: { height: "100vh", overflow: "hidden", background: GRAY100, color: GRAY900, fontFamily: FONT, display: "flex", flexDirection: "column" },
  navbar: { background: "#fff", borderBottom: `1px solid ${GRAY200}`, padding: "0 24px", height: 60, display: "flex", alignItems: "center", justifyContent: "space-between", flexShrink: 0, boxShadow: "0 1px 4px rgba(0,0,0,0.06)" },
  navBrand: { display: "flex", alignItems: "center", gap: 10 },
  navDot: { width: 10, height: 10, borderRadius: "50%", background: ACCENT, boxShadow: `0 0 0 3px ${ACCENT_LT}` },
  navTitle: { fontSize: 18, fontWeight: 800, color: GRAY900, letterSpacing: "-0.02em" },
  body: { display: "flex", flex: 1, overflow: "hidden", minHeight: 0, height: 0 },

  /* LEFT */
  leftPanel: { flex: 1, display: "flex", flexDirection: "column", overflow: "hidden", background: GRAY100, minHeight: 0, height: "100%" },
  leftTop: { padding: "14px 20px 10px", background: "#fff", borderBottom: `1px solid ${GRAY200}`, flexShrink: 0 },
  topRow: { display: "flex", gap: 10, marginBottom: 12 },
  searchWrap: { flex: 1, position: "relative" },
  searchIcon: { position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)", color: GRAY400, fontSize: 14, pointerEvents: "none" },
  searchInput: { width: "100%", background: GRAY50, border: `1.5px solid ${GRAY200}`, borderRadius: 10, color: GRAY900, padding: "9px 12px 9px 36px", fontSize: 14, outline: "none", fontFamily: FONT, boxSizing: "border-box", transition: "border-color 0.2s" },
  customerWrap: { flex: 1, display: "flex", gap: 8, alignItems: "center" },
  nativeSelect: { flex: 1, background: GRAY50, border: `1.5px solid ${GRAY200}`, borderRadius: 10, color: GRAY700, padding: "9px 12px", fontSize: 14, outline: "none", fontFamily: FONT, cursor: "pointer" },
  addBtn: { width: 38, height: 38, borderRadius: 10, background: ACCENT, border: "none", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, color: "#fff", fontSize: 22, fontWeight: 700, lineHeight: 1 },
  categoryBar: { display: "flex", gap: 6, overflowX: "auto", scrollbarWidth: "none" },
  catBtn: (active) => ({ flexShrink: 0, padding: "6px 16px", borderRadius: 20, border: active ? "none" : `1.5px solid ${GRAY200}`, cursor: "pointer", fontSize: 13, fontWeight: 700, background: active ? ACCENT : "#fff", color: active ? "#fff" : GRAY500, fontFamily: FONT, transition: "all 0.15s" }),

  /* PRODUCT GRID */
  productsGrid: { display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(148px, 1fr))", gap: 12, padding: "16px 20px", overflowY: "auto", overflowX: "hidden", flex: "1 1 0", minHeight: 0, alignContent: "start" },
  productCard: (oos) => ({ background: "#fff", border: `1.5px solid ${GRAY200}`, borderRadius: 14, padding: "14px 14px 12px", cursor: oos ? "not-allowed" : "pointer", opacity: oos ? 0.5 : 1, transition: "all 0.18s", userSelect: "none", display: "flex", flexDirection: "column", gap: 8, position: "relative", overflow: "hidden", minHeight: "150px", boxSizing: "border-box" }),
  productBar: (ai) => ({ position: "absolute", top: 0, left: 0, right: 0, height: 3, background: CARD_ACCENTS[ai % CARD_ACCENTS.length].bar, borderRadius: "14px 14px 0 0" }),
  productIconBox: (ai) => ({ width: 36, height: 36, borderRadius: 10, background: CARD_ACCENTS[ai % CARD_ACCENTS.length].bg, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 18, marginTop: 4 }),
  productName: { fontSize: 13, fontWeight: 700, color: GRAY900, lineHeight: 1.4, wordBreak: "break-word" },
  productPrice: (ai) => ({ display: "inline-flex", alignItems: "center", background: CARD_ACCENTS[ai % CARD_ACCENTS.length].bg, color: CARD_ACCENTS[ai % CARD_ACCENTS.length].text, fontSize: 13, fontWeight: 800, padding: "3px 9px", borderRadius: 20 }),
  outBadge: { position: "absolute", top: 10, right: 10, background: DANGER_BG, color: DANGER, fontSize: 10, fontWeight: 700, padding: "2px 7px", borderRadius: 10 },
  qtyBadge: { position: "absolute", top: 10, right: 10, background: ACCENT_LT, color: ACCENT, fontSize: 10, fontWeight: 700, padding: "2px 7px", borderRadius: 10 },

  /* RIGHT PANEL */
  rightPanel: { width: 400, flexShrink: 0, display: "flex", flexDirection: "column", background: "#fff", borderLeft: `1px solid ${GRAY200}`, overflow: "hidden", boxShadow: "-4px 0 20px rgba(0,0,0,0.04)", minHeight: 0 },
  rightHeader: { padding: "14px 20px 10px", borderBottom: `1px solid ${GRAY100}`, flexShrink: 0, background: GRAY50 },
  sLabel: { fontSize: 10, fontWeight: 800, color: GRAY400, letterSpacing: "0.12em", textTransform: "uppercase", marginBottom: 6 },
  chip: (color) => ({ display: "inline-flex", alignItems: "center", gap: 6, background: color ? `${color}14` : ACCENT_LT, border: `1px solid ${color ? `${color}30` : "#BFDBFE"}`, borderRadius: 20, padding: "4px 10px 4px 12px", fontSize: 12, fontWeight: 700, color: color || ACCENT }),
  chipX: { cursor: "pointer", width: 16, height: 16, borderRadius: "50%", background: DANGER_BG, display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: 10, color: DANGER, fontWeight: 700 },
  couponRow: { display: "flex", alignItems: "center", gap: 8, marginBottom: 2 },
  addCouponBtn: { width: 28, height: 28, borderRadius: 8, background: ACCENT_LT, border: `1px solid #BFDBFE`, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 18, color: ACCENT, lineHeight: 1, fontWeight: 700, flexShrink: 0 },

  /* ORDER TABLE */
  orderHead: { display: "grid", gridTemplateColumns: "24px 1fr 88px 68px 24px", gap: 4, padding: "8px 20px", borderBottom: `1px solid ${GRAY100}`, background: GRAY50, flexShrink: 0 },
  th: { fontSize: 10, fontWeight: 800, color: GRAY400, letterSpacing: "0.1em", textTransform: "uppercase" },
  orderList: { flex: 1, minHeight: 0, overflowY: "auto", padding: "8px 12px" },
  emptyState: { display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100%", gap: 10 },
  emptyIcon: { fontSize: 40, opacity: 0.4 },
  emptyText: { fontSize: 13, color: GRAY400, fontWeight: 500 },
  orderRow: { display: "grid", gridTemplateColumns: "24px 1fr 88px 68px 24px", gap: 4, alignItems: "center", padding: "10px 8px", borderRadius: 10, marginBottom: 4, border: `1px solid ${GRAY100}`, background: "#fff", transition: "all 0.15s" },
  orderIdx: { fontSize: 11, color: GRAY400, fontWeight: 700, textAlign: "center" },
  itemName: { fontSize: 13, fontWeight: 700, color: GRAY900, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" },
  itemVar: { fontSize: 11, color: GRAY400, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", marginTop: 1 },
  qtyCtrl: { display: "flex", alignItems: "center", gap: 3 },
  qtyBtn: (t) => ({ width: 22, height: 22, borderRadius: "50%", background: t === "dec" ? DANGER_BG : SUCCESS_BG, border: "none", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 14, color: t === "dec" ? DANGER : SUCCESS, fontWeight: 900, lineHeight: 1, flexShrink: 0, fontFamily: FONT }),
  qtyNum: { fontSize: 13, fontWeight: 800, color: GRAY900, minWidth: 20, textAlign: "center" },
  rowTotal: { fontSize: 13, fontWeight: 800, color: ACCENT, textAlign: "right" },
  delBtn: { width: 22, height: 22, borderRadius: "50%", background: DANGER_BG, border: "none", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 11, color: DANGER, fontWeight: 900 },

  /* TOTALS */
  totalsBox: { borderTop: `1px solid ${GRAY100}`, padding: "14px 20px 10px", background: GRAY50, flexShrink: 0 },
  totRow: { display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 6 },
  totLabel: { fontSize: 13, color: GRAY500 },
  totValue: { fontSize: 13, fontWeight: 600, color: GRAY700 },
  divider: { border: "none", borderTop: `1px solid ${GRAY200}`, margin: "8px 0" },
  grandLabel: { fontSize: 16, fontWeight: 800, color: GRAY900 },
  grandValue: { fontSize: 18, fontWeight: 800, color: ACCENT },
  discountValue: { fontSize: 13, fontWeight: 700, color: SUCCESS },

  /* ACTION BUTTONS */
  actionRow: { display: "flex", gap: 10, padding: "12px 20px 16px", background: "#fff", borderTop: `1px solid ${GRAY100}`, flexShrink: 0 },
  saveBtn: (dis) => ({ flex: 1, padding: "13px 0", borderRadius: 12, border: "none", background: dis ? GRAY100 : ACCENT, color: dis ? GRAY300 : "#fff", fontWeight: 800, fontSize: 14, cursor: dis ? "not-allowed" : "pointer", fontFamily: FONT, transition: "all 0.18s", display: "flex", alignItems: "center", justifyContent: "center", gap: 7 }),
  printBtn: (dis) => ({ flex: 1, padding: "13px 0", borderRadius: 12, border: "none", background: dis ? GRAY100 : SUCCESS, color: dis ? GRAY300 : "#fff", fontWeight: 800, fontSize: 14, cursor: dis ? "not-allowed" : "pointer", fontFamily: FONT, transition: "all 0.18s", display: "flex", alignItems: "center", justifyContent: "center", gap: 7 }),

  /* MODAL */
  overlay: { position: "fixed", inset: 0, background: "rgba(17,24,39,0.45)", backdropFilter: "blur(2px)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center" },
  modal: { background: "#fff", border: `1px solid ${GRAY200}`, borderRadius: 20, width: 480, maxWidth: "95vw", maxHeight: "82vh", display: "flex", flexDirection: "column", overflow: "hidden", boxShadow: "0 20px 60px rgba(0,0,0,0.14)" },
  modalHead: { display: "flex", justifyContent: "space-between", alignItems: "center", padding: "18px 24px", borderBottom: `1px solid ${GRAY100}`, flexShrink: 0 },
  modalTitle: { fontSize: 16, fontWeight: 800, color: GRAY900 },
  modalClose: { width: 30, height: 30, borderRadius: "50%", background: GRAY100, border: "none", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 14, color: GRAY500, fontWeight: 700 },
  modalBody: { padding: "18px 24px", overflowY: "auto", flex: 1 },
  modalFooter: { padding: "14px 24px", borderTop: `1px solid ${GRAY100}`, display: "flex", justifyContent: "flex-end", gap: 10, flexShrink: 0, background: GRAY50 },
  formGrid: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 },
  formGroup: { display: "flex", flexDirection: "column", gap: 5 },
  formLabel: { fontSize: 11, fontWeight: 800, color: GRAY500, letterSpacing: "0.08em", textTransform: "uppercase" },
  formInput: { background: GRAY50, border: `1.5px solid ${GRAY200}`, borderRadius: 10, color: GRAY900, padding: "9px 12px", fontSize: 14, outline: "none", fontFamily: FONT },
  varCard: (oos) => ({ background: oos ? GRAY50 : ACCENT_LT, border: `1.5px solid ${oos ? GRAY200 : "#BFDBFE"}`, borderRadius: 12, padding: "13px 16px", marginBottom: 8, cursor: oos ? "not-allowed" : "pointer", opacity: oos ? 0.5 : 1, display: "flex", justifyContent: "space-between", alignItems: "center", transition: "all 0.15s" }),
  couponGrid: { display: "flex", flexWrap: "wrap", gap: 8 },
  couponPill: { padding: "8px 18px", borderRadius: 20, background: ACCENT_LT, border: `1.5px solid #BFDBFE`, color: ACCENT, fontSize: 13, fontWeight: 700, cursor: "pointer", fontFamily: FONT, transition: "all 0.15s" },
  pmRow: { display: "flex", gap: 12, marginBottom: 20 },
  pmBtn: (active) => ({ flex: 1, padding: "14px 0", borderRadius: 12, border: `2px solid ${active ? ACCENT : GRAY200}`, background: active ? ACCENT_LT : "#fff", color: active ? ACCENT : GRAY500, fontWeight: 800, fontSize: 15, cursor: "pointer", fontFamily: FONT, transition: "all 0.18s" }),
  loader: { position: "fixed", inset: 0, background: "rgba(249,250,251,0.88)", backdropFilter: "blur(4px)", zIndex: 2000, display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: 14 },
  loaderText: { color: ACCENT, fontSize: 15, fontWeight: 700 },
};

/* ─────────────── COMPONENT ─────────────── */
const AddPOSOrder = (props) => {
  const { state } = useLocation();
  const navigate = useNavigate();

  const [inputField, setInputField] = useState([]);
  const [categoryId1, setCategoryId1] = useState("All");
  const [customer, setCustomer] = useState("");
  const [customerLabel, setCustomerLabel] = useState("");
  const [coupon, setCoupon] = useState("");
  const [couponType, setCouponType] = useState("");
  const [couponDiscount, setCouponDiscount] = useState(0);
  const [couponLabel, setCouponLabel] = useState("");
  const [couponAmount, setCouponAmount] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [subTotalAmount, setSubTotalAmount] = useState(0);
  const [taxAmount, setTaxAmount] = useState(0);
  const [afterTaxTotalAmount, setAfterTaxTotalAmount] = useState(0);
  const [taxLabel, setTaxLabel] = useState(0);
  const [cash, setCash] = useState(0);
  const [card, setCard] = useState(0);
  const [orderComment, setOrderComment] = useState("");
  const [otherAmount, setOtherAmount] = useState("");
  const [otherDesc, setOtherDesc] = useState("");
  const [productId, setProductId] = useState("");
  const [productLabel, setProductLabel] = useState("");
  const [showVariation, setShowVariation] = useState(false);
  const [showPayment, setShowPayment] = useState(false);
  const [showCoupon, setShowCoupon] = useState(false);
  const [showAddCustomer, setShowAddCustomer] = useState(false);
  const [newCName, setNewCName] = useState("");
  const [newCPhone, setNewCPhone] = useState("");
  const [newCEmail, setNewCEmail] = useState("");
  const [newCAddress, setNewCAddress] = useState("");
  const [hoveredCard, setHoveredCard] = useState(null);
  const [hoveredRow, setHoveredRow] = useState(null);

  const permissions = JSON.parse(window.localStorage.getItem("permissions") || "[]");
  const checkPermission = (type, name) => permissions.some((p) => p[type] === name);

  const categoryList = !isEmpty(props.categoryList?.data)
    ? [{ value: "All", label: "ALL" }, ...props.categoryList.data.map((x) => ({ value: x._id, label: x.name }))]
    : [{ value: "All", label: "ALL" }];

  const getCustomersList = !isEmpty(props.customerDataList) ? props.customerDataList.map((x) => ({ value: x._id, label: x.name })) : [];
  const getCouponsList = !isEmpty(props.couponsDataList) ? props.couponsDataList.map((x) => ({ value: x._id, label: x.name, type: x.type, amount: x.amount })) : [];
  const getVariationList = !isEmpty(props.productTypeListById)
    ? props.productTypeListById[0].variation.map((x) => ({ value: x._id, label: `${x.colourLabel} — ${x.sizeLabel}`, price: x.salePrice, productBalance: x.productBalance, purchasePrice: x.purchasePrice, wholesalePrice: x.wholesalePrice }))
    : [];

  const handleBarcode = (id) => {
    const found = find(props.productSearchList, { barcodeId: id });
    isEmpty(found) ? Swal({ title: "Warning", text: "No Product Found", icon: "error", button: "Ok" }) : variationData(found);
  };
  useScanDetection(checkPermission("permissionsCatName", "Enable Barcode") ? { onComplete: handleBarcode } : false);

  const handleClickCategory = (item) => {
    setCategoryId1(item.value);
    item.value === "All" ? props.getProductData() : props.serchByMenu(item.value);
  };

  const variationData = (item) => {
    setProductId(item._id);
    setProductLabel(item.name);
    if (item.productTypeName === "Simple Product") {
      insertItem({
        price: item.salePrice,
        label: item.name,
        value: item._id,
        Pquantity: item.productBalance,
        purchasePrice: item.purchasePrice,
        wholesalePrice: item.wholesalePrice,
        isSimple: true,
      });
    } else {
      props.getProductTypeById(item._id);
      setShowVariation(true);
    }
  };

  const insertItem = (item) => {
    const list = [...inputField];
    const idx = list.findIndex((i) => i.productVariationId === item.value);
    if (idx === -1) {
      const newItem = {
        comment: "",
        product: productId || item.value,
        productLabel: productLabel || item.label,
        productVariationId: item.value,
        productVariationLabel: item.isSimple ? "" : item.label,
        quantity: 1,
        Pquantity: item.Pquantity,
        salePrice: Number(item.price),
        productTotalAmount: Number(item.price),
        purchasePrice: Number(item.purchasePrice || 0),
        wholesalePrice: Number(item.wholesalePrice || 0),
      };
      const updated = [...list, newItem];
      recalcTotals(updated);
      setInputField(updated);
    } else {
      if (canIncrement(list[idx])) {
        list[idx].quantity += 1;
        list[idx].productTotalAmount = list[idx].salePrice * list[idx].quantity;
        recalcTotals(list);
        setInputField([...list]);
      }
    }
    setShowVariation(false);
    setProductId("");
    setProductLabel("");
  };

  const changeItemQuantity = (item, dir) => {
    const list = [...inputField];
    const idx = list.findIndex((i) => i.productVariationId === item.productVariationId);
    if (idx === -1) return;
    if (dir === 1) { if (!canIncrement(list[idx])) return; list[idx].quantity += 1; }
    else { if (list[idx].quantity <= 1) return; list[idx].quantity -= 1; }
    list[idx].productTotalAmount = list[idx].salePrice * list[idx].quantity;
    recalcTotals(list);
    setInputField([...list]);
  };

  const removeItem = (varId) => {
    const updated = inputField.filter((i) => i.productVariationId !== varId);
    recalcTotals(updated);
    setInputField(updated);
  };

  const canIncrement = (item) => {
    const avail = item.Pquantity === 0 ? Infinity : Number(item.Pquantity);
    if (item.product === item.productVariationId && item.quantity >= avail) {
      Swal({ title: "Warning", text: "Low Quantity", icon: "info", button: "Ok" });
      return false;
    }
    return true;
  };

  const recalcTotals = (list) => {
    const raw = sumBy(list, "productTotalAmount");
    setTotalAmount(raw);
    if (couponDiscount === 0) {
      setSubTotalAmount(raw);
    } else {
      const dis = couponType === "fixed" ? couponAmount : raw * couponAmount * 0.01;
      setCouponDiscount(dis);
      setSubTotalAmount(raw - dis);
    }
  };

  const handleClickCoupon = (opt) => {
    const dis = opt.type === "fixed" ? opt.amount : totalAmount * opt.amount * 0.01;
    setCoupon(opt.value); setCouponLabel(opt.label); setCouponAmount(opt.amount);
    setCouponType(opt.type); setCouponDiscount(dis); setSubTotalAmount(totalAmount - dis);
    setShowCoupon(false);
  };

  const handleDeleteCoupon = () => {
    setCoupon(""); setCouponLabel(""); setCouponDiscount(0); setCouponAmount(0); setCouponType("");
    setSubTotalAmount(totalAmount);
  };

  const handleChangeCustomer = (e) => {
    const val = e.target.value;
    if (!val) { setCustomer(""); setCustomerLabel(""); return; }
    const found = getCustomersList.find((c) => c.value === val);
    if (found) { setCustomer(found.value); setCustomerLabel(found.label); }
  };

  const handlePaymentType = (type) => {
    if (!props.restaurantList?.[0]) return;
    const r = props.restaurantList[0];
    const isFBR = r.taxType === "FBRTax";
    let taxRate;
    if (type === "cash") {
      setCash(1); setCard(0); taxRate = isFBR ? r.fbrTaxCash : r.praTaxCash;
    } else {
      setCard(1); setCash(0); taxRate = isFBR ? r.fbrTaxCard : r.praTaxCard;
    }
    setTaxLabel(taxRate);
    const tax = (subTotalAmount * taxRate) / 100;
    setTaxAmount(tax);
    setAfterTaxTotalAmount(subTotalAmount + tax);
  };

  const SaveCustomer = () => {
    props.addCustomer(
      { name: newCName, phone: newCPhone, address: newCAddress, email: newCEmail },
      () => { setNewCName(""); setNewCEmail(""); setNewCPhone(""); setNewCAddress(""); setShowAddCustomer(false); props.getCustomerData(); },
      () => { }
    );
  };

  const SaveOrder = (isPrint) => {
    if (subTotalAmount < 0) {
      Swal({
        title: "Error",
        text: "Total Order Amount Is Less Than Paid Amount, Please Change The Coupon",
        icon: "error",
        button: "Ok"
      });
      return;
    }
    props.AddOrderApi({
      isPrint,
      items: inputField,
      grandTotal: parseInt(Number(subTotalAmount) + Number(otherAmount || 0)),
      tax: parseInt(taxAmount), otherAmount: Number(otherAmount || 0),
      otherDesc,
      coupon,
      customer,
      discount: couponLabel === "" ? 0 : parseFloat((totalAmount - subTotalAmount).toFixed(2)),
      subTotal: totalAmount,
      orderComment,
      // customerDetail: { customerName, customerPhone, customerAddress, customerNTN }
    }, (msg) => {
      resetState();
      Swal({
        title: "Success",
        text: msg,
        icon: "success",
        buttons: {
          roll: { text: "Order View", value: "OV" },
          roll2: { text: "Ok", value: "ok" }
        }
      }).then((x) => {
        if (x === "OV") navigate("/view-order");
        else isEmpty(state) ? navigate("/pos-order") : navigate("/table");
      });
    },
      (err) => Swal({ title: "Error", text: err, icon: "error", button: "Ok" })
    );
  };

  const resetState = () => {
    setInputField([]); setTotalAmount(0); setSubTotalAmount(0); setTaxAmount(0);
    setCoupon(""); setCouponLabel(""); setCouponDiscount(0); setCouponAmount(0); setCouponType("");
    setCustomer(""); setCustomerLabel(""); setCash(0); setCard(0);
    setAfterTaxTotalAmount(0); setOrderComment(""); setOtherAmount(""); setOtherDesc("");
    setShowPayment(false);
    props.getProductData();
  };

  useEffect(() => {
    props.getCoupons();
    props.getCustomerData();
    props.getProductData();
    props.getCategoryData();
    props.getRestaurantData();
  }, []);

  const grandTotal = Number(subTotalAmount) + Number(otherAmount || 0);
  const isLoading = props.isFetchingServiceAndHybridProductList || props.isFetchingCouponsData || props.isFetchingCustomer || props.isAddingOrders;
  const hasItems = !isEmpty(inputField);

  return (
    <div style={S.root}>
      {/* NAVBAR */}
      <SinglePageDashbord header='POS Order' />

      {/* LOADER */}
      {isLoading && (
        <GlobalSpinner />
      )}

      {/* BODY */}
      <div style={S.body}>

        {/* ════ LEFT: PRODUCTS ════ */}
        <div style={S.leftPanel}>
          <div style={S.leftTop}>
            <div style={S.topRow}>
              <div style={S.searchWrap}>
                <span style={S.searchIcon}>🔍</span>
                <input
                  style={S.searchInput}
                  placeholder="Search Items…"
                  onFocus={(e) => (e.target.style.borderColor = ACCENT)}
                  onBlur={(e) => (e.target.style.borderColor = GRAY200)}
                  onChange={(e) => props.searchProduct(e.target.value)}
                />
              </div>
              <div style={S.customerWrap}>
                <select style={S.nativeSelect} value={customer} onChange={handleChangeCustomer}
                  onFocus={(e) => (e.target.style.borderColor = ACCENT)}
                  onBlur={(e) => (e.target.style.borderColor = GRAY200)}>
                  <option value="">Select customer…</option>
                  {getCustomersList.map((c) => <option key={c.value} value={c.value}>{c.label}</option>)}
                </select>
                <button style={S.addBtn} title="Add Customer" onClick={() => setShowAddCustomer(true)}
                  onMouseEnter={(e) => (e.currentTarget.style.background = ACCENT_DK)}
                  onMouseLeave={(e) => (e.currentTarget.style.background = ACCENT)}>+</button>
              </div>
            </div>
            <div style={S.categoryBar}>
              {categoryList.map((item) => (
                <button key={item.value} style={S.catBtn(categoryId1 === item.value)} onClick={() => handleClickCategory(item)}>
                  {item.label}
                </button>
              ))}
            </div>
          </div>

          {/* Products */}
          <div style={S.productsGrid}>
            {isEmpty(props.productSearchList) ? (
              <div style={{ gridColumn: "1/-1", textAlign: "center", color: GRAY400, padding: "60px 0", fontSize: 14 }}>No products found</div>
            ) : (
              props.productSearchList.map((item, i) => {
                const oos = item.productBalance <= 0 && item.productTypeName === "Simple Product";
                const ai = i % CARD_ACCENTS.length;
                const isH = hoveredCard === i;
                return (
                  <div
                    key={item._id}
                    style={{ ...S.productCard(oos), boxShadow: isH && !oos ? `0 4px 20px ${CARD_ACCENTS[ai].bar}20` : "0 1px 3px rgba(0,0,0,0.04)", borderColor: isH && !oos ? CARD_ACCENTS[ai].bar : GRAY200, transform: isH && !oos ? "translateY(-2px)" : "none" }}
                    onClick={() => !oos && variationData(item)}
                    onMouseEnter={() => setHoveredCard(i)}
                    onMouseLeave={() => setHoveredCard(null)}
                  >
                    <div style={S.productBar(ai)} />
                    {item.productTypeName === "Simple Product" ? item.productBalance <= 0 ? <div style={S.outBadge}>OUT</div> : <div style={{ ...S.qtyBadge }}>Qty: {item.productBalance}</div> : ''}
                    <div style={S.productIconBox(ai)}> <span>{getCatIcon(item.name)}</span></div>
                    <div style={S.productName}>{item.name}</div>
                    <div style={S.productPrice(ai)}>Rs {item.salePrice}</div>
                  </div>
                );
              })
            )}
          </div>
        </div>

        {/* ════ RIGHT: ORDER ════ */}
        <div style={S.rightPanel}>
          {/* Header */}
          <div style={S.rightHeader}>
            {checkPermission("permissionsCatName", "Assign Coupan") && (
              <div style={{ marginBottom: customerLabel ? 10 : 0 }}>
                <div style={S.sLabel}>Coupon</div>
                <div style={S.couponRow}>
                  <button style={S.addCouponBtn} onClick={() => setShowCoupon(true)}>＋</button>
                  {couponLabel
                    ? <div style={S.chip(SUCCESS)}>{couponLabel}<span style={S.chipX} onClick={handleDeleteCoupon}>✕</span></div>
                    : <span style={{ fontSize: 12, color: GRAY400, fontWeight: 500 }}>No coupon applied</span>
                  }
                </div>
              </div>
            )}
            {/* {customerLabel && (
              <div>
                <div style={S.sLabel}>Customer</div>
                <div style={S.chip()}>👤 {customerLabel}<span style={S.chipX} onClick={() => { setCustomer(""); setCustomerLabel(""); }}>✕</span></div>
              </div>
            )} */}
          </div>

          {/* Table header */}
          <div style={S.orderHead}>
            <span style={S.th}>#</span>
            <span style={S.th}>Item</span>
            <span style={S.th}>Qty</span>
            <span style={{ ...S.th, textAlign: "right" }}>Total</span>
            <span />
          </div>

          {/* Order rows */}
          <div style={S.orderList}>
            {isEmpty(inputField) ? (
              <div style={S.emptyState}>
                <div style={S.emptyIcon}>🛒</div>
                <div style={S.emptyText}>Tap a product to add it here</div>
              </div>
            ) : (
              inputField.map((item, i) => (
                <div
                  key={item.productVariationId}
                  style={{ ...S.orderRow, boxShadow: hoveredRow === i ? "0 2px 12px rgba(37,99,235,0.08)" : "none", borderColor: hoveredRow === i ? "#BFDBFE" : GRAY100 }}
                  onMouseEnter={() => setHoveredRow(i)}
                  onMouseLeave={() => setHoveredRow(null)}
                >
                  <span style={S.orderIdx}>{i + 1}</span>
                  <div style={{ overflow: "hidden" }}>
                    <div style={S.itemName} title={item.productLabel}>{item.productLabel}</div>
                    {item.productLabel !== item.productVariationLabel && <div style={S.itemVar}>{item.productVariationLabel}</div>}
                  </div>
                  <div style={S.qtyCtrl}>
                    <button style={S.qtyBtn("dec")} onClick={() => changeItemQuantity(item, -1)}>−</button>
                    <span style={S.qtyNum}>{item.quantity}</span>
                    <button style={S.qtyBtn("inc")} onClick={() => changeItemQuantity(item, 1)}>+</button>
                  </div>
                  <span style={S.rowTotal}>Rs {item.productTotalAmount}</span>
                  <button style={S.delBtn} onClick={() => removeItem(item.productVariationId)}>✕</button>
                </div>
              ))
            )}
          </div>

          {/* Totals */}
          <div style={S.totalsBox}>
            <div style={S.totRow}>
              <span style={S.totLabel}>Sub Total</span>
              <span style={S.totValue}>Rs {totalAmount}</span>
            </div>
            {couponLabel && (
              <div style={S.totRow}>
                <span style={S.totLabel}>Discount ({couponLabel})</span>
                <span style={S.discountValue}>− Rs {(totalAmount - subTotalAmount).toFixed(2)}</span>
              </div>
            )}
            <hr style={S.divider} />
            <div style={S.totRow}>
              <span style={S.grandLabel}>Grand Total</span>
              <span style={S.grandValue}>Rs {grandTotal}</span>
            </div>
          </div>

          {/* Actions */}
          <div style={S.actionRow}>
            <button style={S.saveBtn(!hasItems)} disabled={!hasItems} onClick={() => SaveOrder(0)}
              onMouseEnter={(e) => { if (hasItems) e.currentTarget.style.background = ACCENT_DK; }}
              onMouseLeave={(e) => { if (hasItems) e.currentTarget.style.background = ACCENT; }}>
              ✓ Save Order
            </button>
            <button style={S.printBtn(!hasItems)} disabled={!hasItems} onClick={() => SaveOrder(1)}
              onMouseEnter={(e) => { if (hasItems) e.currentTarget.style.background = "#047857"; }}
              onMouseLeave={(e) => { if (hasItems) e.currentTarget.style.background = SUCCESS; }}>
              🖨 Save &amp; Print
            </button>
          </div>
        </div>
      </div>

      {/* MODAL: Variation */}
      {showVariation && (
        <div style={S.overlay} onClick={() => setShowVariation(false)}>
          <div style={S.modal} onClick={(e) => e.stopPropagation()}>
            <div style={S.modalHead}>
              <span style={S.modalTitle}>Select Variation</span>
              <button style={S.modalClose} onClick={() => setShowVariation(false)}>✕</button>
            </div>
            <div style={S.modalBody}>
              {props.isFetchingProductTypeById
                ? <div style={{ textAlign: "center", padding: 40 }}><Spinner animation="border" style={{ color: ACCENT }} /></div>
                : isEmpty(getVariationList)
                  ? <p style={{ color: GRAY400, textAlign: "center", fontSize: 14 }}>No variations available.</p>
                  : getVariationList.map((x, i) => {
                    const oos = x.productBalance <= 0;
                    return (
                      <div key={i} style={S.varCard(oos)} onClick={() => !oos && insertItem(x)}
                        onMouseEnter={(e) => { if (!oos) { e.currentTarget.style.borderColor = ACCENT; e.currentTarget.style.background = "#DBEAFE"; } }}
                        onMouseLeave={(e) => { e.currentTarget.style.borderColor = oos ? GRAY200 : "#BFDBFE"; e.currentTarget.style.background = oos ? GRAY50 : ACCENT_LT; }}>
                        <span style={{ fontSize: 14, fontWeight: 700, color: GRAY900 }}>{x.label}</span>
                        <span style={{ fontSize: 14, fontWeight: 800, color: ACCENT }}>Rs {x.price}</span>
                      </div>
                    );
                  })
              }
            </div>
          </div>
        </div>
      )}

      {/* MODAL: Coupon */}
      {showCoupon && (
        <div style={S.overlay} onClick={() => setShowCoupon(false)}>
          <div style={{ ...S.modal, width: 380 }} onClick={(e) => e.stopPropagation()}>
            <div style={S.modalHead}>
              <span style={S.modalTitle}>Select Coupon</span>
              <button style={S.modalClose} onClick={() => setShowCoupon(false)}>✕</button>
            </div>
            <div style={S.modalBody}>
              {props.isFetchingCouponsData
                ? <div style={{ textAlign: "center", padding: 40 }}><Spinner animation="border" style={{ color: ACCENT }} /></div>
                : isEmpty(getCouponsList)
                  ? <p style={{ color: GRAY400, textAlign: "center", fontSize: 14 }}>No coupons available.</p>
                  : <div style={S.couponGrid}>
                    {getCouponsList.map((x, i) => (
                      <div key={i} style={S.couponPill} onClick={() => handleClickCoupon(x)}
                        onMouseEnter={(e) => { e.currentTarget.style.background = ACCENT; e.currentTarget.style.color = "#fff"; e.currentTarget.style.borderColor = ACCENT; }}
                        onMouseLeave={(e) => { e.currentTarget.style.background = ACCENT_LT; e.currentTarget.style.color = ACCENT; e.currentTarget.style.borderColor = "#BFDBFE"; }}>
                        {x.label}
                      </div>
                    ))}
                  </div>
              }
            </div>
          </div>
        </div>
      )}

      {/* MODAL: Add Customer */}
      {showAddCustomer && (
        <div style={S.overlay} onClick={() => setShowAddCustomer(false)}>
          <div style={{ ...S.modal, width: 'auto' }} onClick={(e) => e.stopPropagation()}>
            <div style={S.modalHead}>
              <span style={S.modalTitle}>Add New Customer</span>
              <button style={S.modalClose} onClick={() => setShowAddCustomer(false)}>✕</button>
            </div>
            <div style={S.modalBody}>
              <div style={S.formGrid}>
                {[
                  ["Name *", "text", "Full name", newCName, setNewCName],
                  ["Phone", "tel", "Phone number", newCPhone, setNewCPhone],
                  ["Email", "email", "Email address", newCEmail, setNewCEmail],
                  ["Address", "text", "Address", newCAddress, setNewCAddress],
                ].map(([label, type, placeholder, val, setter]) => (
                  <div key={label} style={S.formGroup}>
                    <label style={S.formLabel}>{label}</label>
                    <input style={S.formInput} type={type} placeholder={placeholder} value={val}
                      onFocus={(e) => (e.target.style.borderColor = ACCENT)}
                      onBlur={(e) => (e.target.style.borderColor = GRAY200)}
                      onChange={(e) => setter(e.target.value)} />
                  </div>
                ))}
              </div>
            </div>
            <div style={S.modalFooter}>
              <button
                style={{ ...S.saveBtn(!newCName || !newCEmail || !newCPhone || !newCAddress), flex: "none", padding: "11px 28px" }}
                disabled={!newCName || !newCEmail || !newCPhone || !newCAddress}
                onClick={SaveCustomer}>
                Save Customer
              </button>
            </div>
          </div>
        </div>
      )}

      {/* MODAL: Payment */}
      {showPayment && (
        <div style={S.overlay} onClick={() => setShowPayment(false)}>
          <div style={{ ...S.modal, width: 360 }} onClick={(e) => e.stopPropagation()}>
            <div style={S.modalHead}>
              <span style={S.modalTitle}>💳 Payment Method</span>
              <button style={S.modalClose} onClick={() => setShowPayment(false)}>✕</button>
            </div>
            <div style={S.modalBody}>
              <div style={S.pmRow}>
                <button style={S.pmBtn(cash === 1)} onClick={() => handlePaymentType("cash")}>💵 Cash</button>
                <button style={S.pmBtn(card === 1)} onClick={() => handlePaymentType("card")}>💳 Card</button>
              </div>
              {[
                ["Total Amount", `Rs ${totalAmount}`, false],
                couponLabel ? [`Coupon (${couponLabel})`, `− Rs ${couponDiscount.toFixed(2)}`, "discount"] : null,
                ["Sub Total", `Rs ${subTotalAmount}`, false],
                [`Tax (${taxLabel}%) — ${cash ? "Cash" : card ? "Card" : "—"}`, `Rs ${taxAmount.toFixed(2)}`, false],
                ["Total After Tax", `Rs ${afterTaxTotalAmount.toFixed(2)}`, "grand"],
              ].filter(Boolean).map(([label, value, type], i) => (
                <div key={i} style={{ ...S.totRow, borderBottom: i === 2 ? `1px solid ${GRAY100}` : "none", paddingBottom: 6 }}>
                  <span style={S.totLabel}>{label}</span>
                  <span style={type === "grand" ? S.grandValue : type === "discount" ? S.discountValue : S.totValue}>{value}</span>
                </div>
              ))}
            </div>
            <div style={S.modalFooter}>
              <button style={{ ...S.saveBtn(!cash && !card), flex: "none", padding: "11px 24px" }} disabled={!cash && !card} onClick={() => SaveOrder(0)}>Save</button>
              <button style={{ ...S.printBtn(!cash && !card), flex: "none", padding: "11px 24px" }} disabled={!cash && !card} onClick={() => SaveOrder(1)}>Save &amp; Print</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

/* ─────────────── REDUX ─────────────── */
const mapDispatchToProps = (dispatch) => ({
  AddOrderApi: (data, onSuccess, onError) => dispatch(AddOrderApi(data, onSuccess, onError)),
  addCustomer: (data, onSuccess, onError) => dispatch(addCustomer(data, onSuccess, onError)),
  getRestaurantData: () => dispatch(getRestaurantData()),
  getProductData: () => dispatch(getProductData()),
  getCategoryData: () => dispatch(getCategoryData()),
  getCoupons: () => dispatch(getCoupons()),
  getCustomerData: () => dispatch(getCustomerData()),
  getProductTypeById: (id) => dispatch(getProductTypeById(id)),
  searchProduct: (data) => dispatch(filterItem(data)),
  serchByMenu: (id) => dispatch(filterItemByMenu(id)),
});

const mapStateToProps = (state) => ({
  isAddingOrders: state.POSReducer.isAddingOrders,
  isFetchingCustomer: state.CustomerReducer.isFetchingCustomer,
  customerDataList: state.CustomerReducer.customerDataList,
  isFetchingCouponsData: state.CouponReducer.isFetchingCouponsData,
  couponsDataList: state.CouponReducer.couponsDataList,
  isFetchingProductTypeById: state.RecipeReducer.isFetchingProductTypeById,
  productTypeListById: state.RecipeReducer.productTypeListById,
  isFetchingServiceAndHybridProductList: state.ProductReducer.isFetchingServiceAndHybridProductList,
  productDataList: state.ProductReducer.productDataList,
  categoryList: state.CategoryReducer.categoryList,
  restaurantList: state.ResturantReducer.restaurantDataList,
  // OrderDataByID: state.POSViewReducer.OrderDataByID,
  productSearchList: state.ProductReducer.productSearchList,
});

export default connect(mapStateToProps, mapDispatchToProps)(AddPOSOrder);